<div class="banner-chat">
  <a class="dashdirect-chat vcenter" (click)="this.irChat()">
    <img class="direct-chat-i" width="100%" src="../../assets/images/chatnow-icon.png">
    <span class="tabcell">Chatea con Nosotros</span>
  </a>
</div>